<template>
  <div>
    <ul id="course" class="course mt-6 px-4 pb-6">
      <li>
        <a :name="'plan_place_' + String(0)"></a>
        <plan-station
          :editable="editable"
          :station="departure"
          :route="routes[0]"
          :routeIndex="0"
          :showDepartureModal="() => showModal('departure')" />
      </li>
      <li v-for="route in routes" v-bind:key="route.index">
        <div class="route pb-10">
          <add-place
            v-if="destinations[route.index - 1] && (destinations[route.index - 1].disableAddPlace === undefined || destinations[route.index - 1].disableAddPlace === false)"
            :editable="editable"
            :newPlaceFromMap="() => newPlaceFromMap(route)"
            :newPlace="() => showModal('place', { route: route })" 
            :newPlaceFromFavorites="() => showModal('placeFromFavorites', { route: route })" />
          <div v-for="course in route.courses" v-bind:key="course.courseIndex">
            <route :route="getRouteData(route, course.courseIndex)" :editable="editable" :isNotInTime="checkArrivalTime(route, course.courseIndex, destinations[route.index])"/>
            <route-link :route="getRouteData(route, course.courseIndex)"/>
          </div>
        </div>
        <a :name="'plan_place_' + String(route.index + 1)"></a>
        <plan-place
          v-if="destinations[route.index]"
          :routeIndex="route.index + 1"
          :editable="editable"
          :place="destinations[route.index]"
          :route="route"
          :next="routes[route.index + 1]"
          :changeVisit="() => showModal('time', { destination: destinations[route.index], route: route })"
          :deleteDestination="() => deleteDestination(destinations[route.index])" />
      </li>
      <li>
        <a :name="'plan_place_' + String(routes.length)"></a>
        <plan-station
          :isDeparture=false
          :editable="editable"
          :station="arrival"
          :route="routes.slice(-1)[0]"
          :routeIndex="routes.length"
          :showDepartureModal="() => showModal('arrival')" />
      </li>
    </ul>
    <plan-modal
      v-if="editable"
      v-show="modal.show"
      :closeModal="() => closeModal()"
      :modals=modals
      :kind=modal.kind
      :target=modal.target />
  </div>
</template>

<script>
import PlanPlace from "../molecules/PlanPlace"
import PlanStation from "../molecules/PlanStation"
import PlanModal from "../molecules/PlanModal"
import Route from "../molecules/Route"
import Departure from "../molecules/Departure"
import Arrival from "../molecules/Arrival"
import Time from "../molecules/Time"
import NewPlace from "../molecules/NewPlace"
import AddPlace from "../molecules/AddPlace"
import RouteLink from "../molecules/RouteLink"
import { mapGetters } from 'vuex'
import NewPlaceFromFavorites from '../molecules/NewPlaceFromFavorites'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    PlanPlace,
    PlanStation,
    PlanModal,
    Route,
    AddPlace,
    RouteLink
  },
  props: {
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      places: [],
      modal: {
        show: false,
        kind: 'departure',
        target: undefined
      }
    }
  },
  methods: {
    closeModal: function () {
      this.modal.show = false
    },
    showModal: function (kind, target = {}) {
      this.modal.show = true
      this.modal.kind = kind
      this.modal.target = target
    },
    setDeparture: function (name) {
      this.$store.dispatch('destinations/updateDepartureStation', name)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    setArrival: function (name) {
      this.$store.dispatch('destinations/updateArrivalStation', name)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    deleteDestination: function (destination) {
      this.$store.dispatch('destinations/deleteDestination', destination)
      this.$store.dispatch('routes/search')
    },
    timeUpdate: function (destination, time, arrivalTime) {
      const params = {
        destination: destination,
        visit: time,
        arrivalTime: arrivalTime
      }
      this.$store.dispatch('destinations/updateTime', params)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    addPlace: function (route, time, place) {
      // GoogleAnalytics
      this.$gtag.event("プランにPOI追加", {
        poi_name: place.name,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      this.$store.dispatch('destinations/spliceDestination', { route: route, visit: time, place: place })

      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    newPlaceFromMap: function (route) {
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'], route: route }})
    },
    getRouteData: function (route, courseIndex) {
      var p = Object.assign({}, route);
      p.course = p.courses[courseIndex]
      return p
    },
    showDepartureDate: function (place) {
      if (place !== undefined) {
        return place.genreIds.includes('stay')
      }
    },
    checkArrivalTime: function (route, courseIndex, destination) {
      // 滞在地の前のルートのとき、到着時刻が滞在地の開始時刻（チェックイン）に間に合うかチェック
      if ((destination) && (destination.checkIn))  {
        var p = Object.assign({}, route);
        const checkInTime = moment(destination.checkIn)
        if (p.courses[courseIndex].points[1].arrivalTime > checkInTime) {
          return true
        }
      }
      return false
    }
  },
  computed: {
    ...mapGetters({
      departure: 'destinations/getDepatureStation',
      arrival: 'destinations/getArrivalStation',
      routes: 'routes/getAll',
      destinations: 'destinations/getAll',
      destinationEditable: 'destinations/getEditable'
    }),
    modals: function () {
      return {
        'departure' : {
          callback: (name) => this.setDeparture(name),
          component: Departure
        },
        'arrival' : {
          callback: (name) => this.setArrival(name),
          component: Arrival
        },
        'time' : {
          callback: (destination, time, arrivalTime) => this.timeUpdate(destination, time, arrivalTime),
          component: Time
        },
        'place' : {
          callback: (index, time, place) => this.addPlace(index, time, place),
          component: NewPlace
        },
        'placeFromFavorites' : {
          callback: (index, time, place) => this.addPlace(index, time, place),
          component: NewPlaceFromFavorites
        }
      }
    },
    isError: function () {
      return this.$store.getters['routes/isError']
    },
    departureTime: function () {
      return this.routes[0] && this.routes[0].departureTime
    },
    arrivalTime: function () {
      return this.routes.slice(-1)[0] && this.routes.slice(-1)[0].arrivalTime
    }
  },
  watch: {
    isError: function (val)  {
      const m = this.$t('not_found_route_message')
      if (val) this.$alert({ message: m })
    },
    destinationEditable: function (val)  {
      if (val !== null) {
        location.hash = '#plan_place_' + String(val.index + 1)
      }
    }
  }
}
</script>
